import { CONSTRUCTOR } from '..';
import * as Fragments from './fragments';

// LeadField GraphQL Queries.

// READ read lead field GraphQL schema.
export const READ = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getLeadFieldSettings',
    args: [],
    argsMap: [],
    fields: '{...LeadFieldSettingsResponseFields}',
    fragments: [Fragments.leadFieldSettingsResponse],
  };
  let options = defaultProps;
  if (props) {
    options = Object.assign(defaultProps, props);
  }
  return CONSTRUCTOR.GRAPHQL(options);
};
// GET_DASHBOARD_METRICS get dashboard metrics GraphQL schema.
export const GET_DASHBOARD_METRICS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getDashboardMetrics',
    args: [],
    argsMap: [],
    fields: '{...GetDashboardMetricsResponseFields}',
    fragments: [Fragments.getDashboardMetricsResponse],
  };
  let options = defaultProps;
  if (props) {
    options = Object.assign(defaultProps, props);
  }
  return CONSTRUCTOR.GRAPHQL(options);
};

// LIST_ACTION_STATUSES - get all action statuses
export const LIST_ACTION_STATUSES = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getActionStatuses',
    args: [],
    argsMap: [],
    fields: '{...ActionStatusResponseFields}',
    fragments: [Fragments.actionStatusResponseFields],
  };
  let options = defaultProps;
  if (props) {
    options = Object.assign(defaultProps, props);
  }
  return CONSTRUCTOR.GRAPHQL(options);
};

// READ_ACTION_STATUS - get single action status by ID
export const READ_ACTION_STATUS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getActionStatus',
    args: [
      { name: 'id', type: 'ID', required: true },
    ],
    argsMap: [
      { name: 'id', value: 'id' },
    ],
    fields: '{...ActionStatusResponseFields}',
    fragments: [Fragments.actionStatusResponseFields],
  };
  let options = defaultProps;
  if (props) {
    options = Object.assign(defaultProps, props);
  }
  return CONSTRUCTOR.GRAPHQL(options);
};

export default READ;
